import React from 'react'
import Planets from '../components/Planets'
import Search from '../components/Search'
import Options from '../components/Options'
import { Header } from 'semantic-ui-react'
import { Parallax } from 'react-parallax'

const App = () => (
  <div>
  	<Parallax bgImage="images/header.jpg" strength={-400}>
		<Header style={{ fontWeight: 100, fontSize: '40pt', textAlign: 'center', paddingTop: 200 }} inverted as='h1'>Planet Search</Header>
    	<Search />
    </Parallax>
    <Options />
  	<Planets />
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/components/App.js